import FunctionalButton from "components/layout/FunctionalButton";

const ARCErrorPanel = ({ className = "bg-black", title = "", subTitle, onClick = () => {} }) => {
    return (
        <div
            className={`page-with-top-bar flex flex-col items-center justify-center space-y-2 ${className}`}
        >
            <p className="text-h3 font-bold transition-all">{title}</p>
            {subTitle && <p className="text-h4 transition-all">{subTitle}</p>}
            <FunctionalButton
                className="h-10 w-64 rounded-full bg-primary transition-all hover:bg-primary2 tablet:w-50"
                title="Select ARC"
                titleClassName="text-h4"
                onClick={onClick}
            />
        </div>
    );
};

export default ARCErrorPanel;
